import GreenCheck from "@/assets/GreenCheck.png";
import {
  formatDate,
  formatMoney,
  formatVestingSchedule,
} from "@/utils/generalUtilities";
import React from "react";
import { useTranslation } from "react-i18next";
import { UserBenefitData } from "../types";

interface BenefitsListProps {
  userData: UserBenefitData;
}

const BenefitsList: React.FC<BenefitsListProps> = ({ userData }) => {
  const { t } = useTranslation();

  const renderCheckItem = (title: string, content: React.ReactNode) => (
    <li className="flex items-start">
      <img src={GreenCheck} alt="Green Check" className="w-4 mt-2 mx-2" />
      <p>
        <span className="font-semibold">{title}</span> {content}
      </p>
    </li>
  );

  const hasEmployerMatch = userData.EmployerMaxContribution !== "0";

  return (
    <div className="mb-6">
      {/* <h3 className="text-[16px] mb-4 text-black/50">
        A few important things to know:
      </h3> */}

      <ul className="space-y-4 mb-6">
        {hasEmployerMatch &&
          renderCheckItem(
            t("onboarding.intro.benefits_list.employer_match_title"),
            t("onboarding.intro.benefits_list.employer_match_description", {
              percentage: userData.EmployerMaxContribution,
              salary: formatMoney(Number(userData.EmployeeSalary)),
            }),
          )}

        {hasEmployerMatch &&
          renderCheckItem(
            t("onboarding.intro.benefits_list.annual_match_limit_title"),
            t("onboarding.intro.benefits_list.annual_match_limit_description", {
              limit: formatMoney(Number(userData.BenefitContributionLimit)),
            }),
          )}

        {hasEmployerMatch &&
          renderCheckItem(
            t("onboarding.intro.benefits_list.vesting_title"),
            userData.VestingScheduleName === "Immediately"
              ? t("onboarding.intro.benefits_list.vesting_immediate")
              : t("onboarding.intro.benefits_list.vesting_scheduled", {
                  schedule: formatVestingSchedule(userData.VestingScheduleName),
                }),
          )}

        {userData?.BenefitPlanStartDate &&
          renderCheckItem(
            t("onboarding.intro.benefits_list.start_date_title"),
            t("onboarding.intro.benefits_list.start_date_description", {
              date: formatDate(userData.BenefitPlanStartDate),
            }),
          )}
      </ul>
    </div>
  );
};

export default BenefitsList;
